import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
  closeButton: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2, 0),
    cursor: "pointer",
  },
  fullHeigth: {
    height: "100vh",
  },
}));

export default function AlertDialog({
  buttonCloseText,
  description,
  onClose,
  open,
  title,
  dialogClassName,
  buttonClassName,
  actionButton,
  maxWidth,
}) {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      open={open}
      keepMounted
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      className={classes.fullHeigth}
    >
      <div className={classes.closeButton}>
        {title}
        <Close color="secondary" onClick={onClose} />
      </div>
      <DialogContent>{description}</DialogContent>
      <DialogActions className={classes.buttonContainer}>
        {/* <Button onClick={onClose} color="secondary" className={clsx(buttonClassName, classes.closeButton)}>
          {buttonCloseText}
        </Button> */}
        {actionButton}
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  buttonCloseText: PropTypes.node.isRequired,
  description: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.any,
  maxWidth: PropTypes.string,
};

AlertDialog.defaultProps = {
  title: null,
  maxWidth: "xl",
};
